<template>
    <v-app>
        <v-app-bar app color="primary" dark>
            <div class="d-flex align-center">
                <v-img
                    class="shrink mr-2"
                    contain
                    :src="require('./assets/CuratorLogo.svg')"
                    transition="scale-transition"
                    width="200" />
            </div>

            <v-spacer></v-spacer>
            Logger UI-Schema builder
            <v-spacer></v-spacer>

            <v-btn
                href="https://ipvltd.atlassian.net/wiki/spaces/DEV/pages/1942355997/Logger+Views+Configuration"
                target="_blank"
                text>
                <span class="mr-2">Confluence</span>
                <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
        </v-app-bar>

        <v-main>
            <v-container>
                <v-select v-model="type" :items="types" label="Component type" item-text="name" item-value="value" />
            </v-container>
            <v-container class="optionsPanel">
                <v-subheader>Component options</v-subheader>
                <component :is="type" @change="change"/>
                <v-subheader>Common options</v-subheader>
                <v-row>
                    <v-col>
                        <v-text-field v-model="minHeight" label="Min height"/>
                        <span class="body-2 text--secondary">The minimum height of the container for the control, e.g. 50px, 100%. This can be used to push other controls down so that they appear in the next column.</span>
                    </v-col>
                    <v-col>
                        <v-text-field v-model="maxHeight" label="Max height"/>
                        <span class="body-2 text--secondary">The maximum height of the container for the control, e.g. 50px, 100%. This can be used to push other controls down so that they appear in the next column.</span>
                    </v-col>
                    <v-col>
                        <v-text-field v-model="height" label="Height"/>
                        <span class="body-2 text--secondary">The height of the container for the control, e.g. 50px, 100%. Use with care overrides min and max heights.</span>
                    </v-col>
                    <v-col>
                        <v-select v-model="isFieldTab" :items="['Enabled', 'Disabled', 'Default']" label="Tabbable"/>
                        <span class="body-2 text--secondary">Whether the control is highlighted when tab is pressed. By default, controls with text boxes (text, auto-complete) are tabbable.</span>
                    </v-col>
                    <v-col>
                        <v-checkbox v-model="hasPersist" label="Persist value" />
                        <span class="body-2 text--secondary">If enabled, the lock button is visible, which allows the user to persist their data in the control when pressing the clear or save buttons.</span>
                    </v-col>
                </v-row>
            </v-container>
            <v-card class="bottom">
                <v-container>
                    <v-row>
                        <v-col>
                            <v-text-field outlined hide-details readonly :value="schema" label="UI Schema"/>
                            <v-btn icon @click="copy(schema)">
                                <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <v-snackbar v-model="snackbar">
                Copied to clipboard!
                <template v-slot:action="{ attrs }">
                    <v-btn
                    color="primary"
                    text
                    v-bind="attrs"
                    @click="snackbar = false">
                    Close
                    </v-btn>
                </template>
            </v-snackbar>
        </v-main>
    </v-app>
</template>

<script>
import TextComp from './components/Text';
import Buttons from './components/Buttons';
import DateTime from './components/DateTime';
import Dropdown from './components/Dropdown';
import AutoComplete from './components/AutoComplete';
import LoggerTable from './components/LoggerTable';
import Sequence from './components/Sequence';
import SwitchComp from './components/Switch';
import ToggleButton from './components/ToggleButton';

export default {
    name: 'App',
    components: {
        TextComp,
        Buttons,
        DateTime,
        Dropdown,
        AutoComplete,
        LoggerTable,
        Sequence, 
        SwitchComp,
        ToggleButton
    },
    data: () => ({
        type: 'TextComp',
        types: [{name:'Buttons', value:'Buttons'}, 
            {name:'Text', value: 'TextComp'}, 
            {name:'Date Time', value: 'DateTime'}, 
            {name:'Dropdown', value: 'Dropdown'}, 
            {name:'Auto-complete', value: 'AutoComplete'}, 
            {name:'Logger Table', value: 'LoggerTable'},
            {name:'Sequence', value: 'Sequence'},
            {name: 'Switch', value: 'SwitchComp'},
            {name: 'Toggle', value: 'ToggleButton'}],
        minHeight: null,
        maxHeight: null,
        height: null,
        isFieldTab: 'Default',
        hasPersist: null,
        value: null,
        snackbar: false
    }),
    methods: {
        change(val) {
            this.value = val;
        },
        copy(msg) {
            this.$copyText(msg).then(() => {
                this.snackbar = true;
            });
        }
    },
    computed: {
        schema() {
            let opts = Object.assign({}, this.value);
            if(this.minHeight) {
                opts.minHeight = this.minHeight;
            }

            if(this.maxHeight) {
                opts.maxHeight = this.maxHeight;
            }

            if(this.height) {
                opts.height = this.height;
            }

            if(this.isFieldTab != 'Default') {
                opts.isFieldTab = this.isFieldTab == 'Enabled';
            }

            if(this.hasPersist != null) {
                opts.hasPersist = this.hasPersist;
            }

            return JSON.stringify(opts);
        }
    }
};
</script>

<style lang="scss" scoped>
    .optionsPanel {
        height: calc(100vh - 64px - 94px - 104px);
        overflow-x: hidden;
        overflow-y: auto;
    }
    .bottom {
        position: absolute;
        width: 100%;
        bottom: 0;

        .col {
            display: flex;
            align-items: center;
        }
    }
</style>
